<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pb-0">
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-autocomplete v-model="filterChart.wh_id" outlined dense hide-details label="Warehouse" class="width-0" no-data-text="Tidak ada data tersedia" :items="listWarehouse" item-text="warehouse_name" item-value="warehouse_id"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="searchDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(filterChart.filterDate)" label="Tanggal" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Maksimal 7 hari" hide-details @click:clear="filterChart.filterDate = []"></v-text-field>
								</template>
								<v-date-picker clearable locale="id" first-day-of-week="0" range color="primary" v-model="filterChart.filterDate" :max="maxDate"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" class="pt-5">
							<div class="border border-light rounded">
								<div class="px-2 ml-2 mt-n3 white" style="width: fit-content;">Produk</div>
								<div class="pb-3 px-3">
									<v-checkbox v-for="data in optionMainProduct" v-model="filterChart.product_id" :value="data.product_id" :key="data.product_id" :label="data.product_name" class="mt-2" hide-details></v-checkbox>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded text-capitalize" @click="getFilter">
						<v-icon small>mdi-magnify</v-icon>
						<span class="pl-1">Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			searchDate: false,
			filterDate: [],
		}
	},
	computed:{
		...mapState('dashboardAll', ['optionMainProduct', 'optionWarehouse']),

		listWarehouse () {
			let all_wh = {
				warehouse_name: 'Semua Warehouse',
				warehouse_id: null
			}
			return [all_wh, ...this.optionWarehouse]
		},
		maxDate() {
			return this.today
		},
	},
	props: {
		filterChart: {
			type: Object
		}
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		getFilter() {
			this.$emit('filterResume', this.filterChart)
			this.modalHide()
		}
	}
};
</script>